import {UNIT} from '@di-shared/const';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import LinkTo from '@di-shared/features/navigate/LinkTo';
import Popper from '@di-shared/features/common/Popper';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import MyMaintenanceGradeLoading from '@di-shared/features/diag/cpo/MyMaintenanceGradeLoading';
import useUnitConverter from '@di-shared/utils/useUnitConverter';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

function DiagCpoContentsLoading() {
  const {t} = useInferableTranslation();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const {convertDistanceValue, convertDistanceSymbol} = useUnitConverter();
  return (
    <main
      id="content"
      className="content page_car_management"
    >
      <section className="section section_car_certification">
        <section className="section section_certification_comprehensive">
          <div className="section_container">
            <div className="section_container_header skeleton">
              <h2
                className="title_medium_b"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20217_$name_$carName', {name: '슈퍼붕붕이', carName: 'g80'})}
              </h2>
              <div className="my_comprehensive_grade">
                <span className={clsx('ic ic_certification_grade grade_s')}>
                  <span className="blind">{t('T20218_$grade', {grade: 'S'})}</span>
                </span>
              </div>
            </div>
            <span className="section_container_caption skeleton">
              {t('T20219_$agreeDate', {
                agreeDate: CldrDatetimeFormatter.format(new Date(), 'yMMMaHM'),
              })}
            </span>
            {/* [D] comprehensive_grade에 혜택 미대상일 경우 type_null 클래스 추가, 에러 케이스일 경우 type_error 클래스 추가 */}
            <div className={clsx('comprehensive_grade')}>
              <span
                className="comprehensive_grade_item grade_s skeleton"
                aria-current={false}
                style={{height: '15px'}}
              >
                <span className="grade_text"></span>
                <span className="speech_bubble">{t('T20220')}</span>
              </span>
            </div>

            <ul className="statistics_info_list skeleton">
              <li className="statistics_info_item">
                <span className="statistics_info_key">{t('T20225')}</span>
                <span className="statistics_info_val">
                  <span className="statistics_info_number">{t('T20218_$grade', {grade: 'S'})}</span>
                  <span className="statistics_info_unit"></span>
                </span>
              </li>
              <li className="statistics_info_item">
                <span className="statistics_info_key">{t('T20226')}</span>
                <span className="statistics_info_val">
                  <span className="statistics_info_number">{t('T20218_$grade', {grade: 'S'})}</span>
                  <span className="statistics_info_unit"></span>
                </span>
              </li>
            </ul>
          </div>

          <div className="driving_banner type_square skeleton">
            <LinkTo
              to={'#'}
              className={'driving_banner_box'}
            >
              <span className="driving_banner_txtbox type_reverse">
                <strong className="driving_banner_title body_large_b">{t('T20229')}</strong>
                <span className="driving_banner_desc body_small_r">{t('T20228')}</span>
              </span>
              <span className="driving_banner_imgbox">
                <ImageSelector
                  className="driving_banner_img"
                  alt="driving_banner_img"
                  kiaLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  kiaDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  hyundaiLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  hyundaiDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  genesisLightSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_guide.png')}
                  genesisDarkSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_guide.png')}
                />
              </span>
            </LinkTo>
          </div>
        </section>
        <MyMaintenanceGradeLoading />
        <section className="section section_certification_driving">
          <div className="section_container_header">
            <h3 className="title_medium_b">{t('T20226')}</h3>
            <div className="my_grade">
              <span className={clsx('ic ic_certification_grade')}>
                <span className="blind">{t('T20218_$grade', {grade: 'S'})}</span>
              </span>
            </div>
          </div>
          <div className="section_container">
            <div className="certification_driving_head skeleton">
              <strong
                className="certification_driving_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20233_$carName', {carName: '슈퍼붕붕이'})}
              </strong>

              <Popper
                placement="bottom"
                className="tooltip"
                tooltip={
                  <div
                    tabIndex={0}
                    role="tooltip"
                  >
                    <strong className="tooltip_title">{t('T20242')}</strong>
                    <ul className="tooltip_list">
                      <li className="tooltip_item">{t('T20243')}</li>
                    </ul>
                    <div className="tooltip_table">
                      <table>
                        <caption>
                          <span className="blind">{t('T20244')}</span>
                        </caption>
                        <colgroup>
                          <col />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col">{t('T20245')}</th>
                            <th scope="col">{t('T20246')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">{t('T20247')}</th>
                            <td>{t('T20220')}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t('T20248')}</th>
                            <td>{t('T20221')}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t('T20249')}</th>
                            <td>{t('T20222')}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t('T10135')}</th>
                            <td>{t('T20227')}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              >
                <div className="tooltip_area tooltip_area_single">
                  <button
                    type="button"
                    className="btn_tooltip"
                    aria-describedby="tooltipBox01"
                    aria-controls="tooltipStatement01"
                    aria-expanded="false"
                  >
                    <span
                      className="ic ic_information_16px"
                      aria-hidden="true"
                    ></span>
                    <span className="blind">{t('T10044')}</span>
                  </button>
                </div>
              </Popper>
            </div>

            <ul className="certification_info_list skeleton">
              <li className="certification_info_item">
                <span className="certification_info_title">{'g80'}</span>
                <span className="certification_info_value">
                  <span className="certification_info_text"> {t('T20053')}</span>
                  <span className="certification_info_number">
                    42
                    {UNIT.PERCENT}
                  </span>
                </span>

                <div className="badge_box">
                  <span className="badge badge_basic_container badge_20px">{t('T20231_$score', {score: '100'})}</span>
                </div>
              </li>
              <li className="certification_info_item">
                <span className="certification_info_title">{t('T20022')}</span>
                <span className="certification_info_value">
                  <span className="certification_info_number">{convertDistanceValue(600)}</span>
                  <span className="certification_info_unit">{convertDistanceSymbol(600)}</span>
                </span>

                <div className="badge_box">
                  <span className="badge badge_basic_container badge_20px">{t('T20232')}</span>
                </div>
              </li>
            </ul>
          </div>

          <div className="driving_banner type_square skeleton">
            <LinkTo
              to={'#'}
              className="driving_banner_box"
            >
              <span className="driving_banner_txtbox type_reverse">
                <strong className="driving_banner_title body_large_b">{t('T30256')}</strong>
                <span className="driving_banner_desc body_small_r">{t('T30257')}</span>
              </span>
              <span className="driving_banner_imgbox">
                <ImageSelector
                  className="driving_banner_img"
                  alt="driving_banner_img"
                  kiaLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  kiaDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  hyundaiLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  hyundaiDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  genesisLightSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_safe_score.png')}
                  genesisDarkSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_safe_score.png')}
                />
              </span>
            </LinkTo>
          </div>
        </section>
      </section>
    </main>
  );
}

export default DiagCpoContentsLoading;
